import React from 'react';
import { useConnect } from '@lore/query-connect';
import useStewardshipFilter from '../../partners/useStewardshipFilter';
import { PayloadStates } from '@lore/utils';
import MetricLoader from '../MetricLoader';
import moment from 'moment-timezone';
import ComparisonMetric from '../ComparisonMetric';
import { project_networkId, tags_partner } from '../../../utils/query-helpers';

export default function CreatedInviteToProject(props) {
  const { network, schoolStart, schoolEnd, titleOnly } = props;

  const stewardshipFilter = useStewardshipFilter();

  const previousSchoolStart = moment(schoolStart).subtract(1, 'year').toISOString();

  const previousUsers = useConnect('user.find', {
    where: {
      eager: {
        $aggregations: [
          {
            type: 'count',
            alias: 'numberOfCreatedQuestions',
            relation: 'createdQuestions',
            $where: {
              projectId: {
                $null: false
              },
              ...project_networkId(network),
              createdAt: {
                $lte: schoolStart,
                $gte: titleOnly ? undefined : previousSchoolStart
              }
            }
          }
        ],
        $where: {
          ...tags_partner(),
          $or: stewardshipFilter
        },
        $having: {
          numberOfCreatedQuestions: {
            $gte: 1
          }
        }
      },
    },
    pagination: {
      pageSize: 1
    }
  });

  const newUsers = useConnect('user.find', {
    where: {
      eager: {
        $aggregations: [
          {
            type: 'count',
            alias: 'numberOfCreatedQuestions',
            relation: 'createdQuestions',
            $where: {
              projectId: {
                $null: false
              },
              ...project_networkId(network),
              createdAt: {
                $lte: schoolEnd,
                $gte: schoolStart
              }
            }
          }
        ],
        $where: {
          ...tags_partner(),
          $or: stewardshipFilter
        },
        $having: {
          numberOfCreatedQuestions: {
            $gte: 1
          }
        }
      },
    },
    pagination: {
      pageSize: 1
    }
  });

  if (
    previousUsers.state === PayloadStates.FETCHING ||
    newUsers.state === PayloadStates.FETCHING
  ) {
    return (
      <MetricLoader
        name="Initiated contact with Educator about Project"
      />
    );
  }

  return (
    <ComparisonMetric
      name="Initiated contact with Educator about Project"
      value={newUsers.meta.totalCount}
      previousValue={previousUsers.meta.totalCount}
      titleOnly={titleOnly}
    />
  );
}
